var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1638501335251,
    className: "icon",
    viewBox: "0 0 1527 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 6239,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.516818 1014.48504h1508.596916V11.227653H7.611968v1003.257387z m1515.352537 9.51496v-9.51496 9.51496zM1.236945 1020.764914V4.947779H1522.393607v1015.817135H1.236945z",
    fill: "#353636",
    "p-id": 6240
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.805984 7.516818h1514.781639V512.856346H3.805984z",
    fill: "#E24654",
    "p-id": 6241
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.805984 512.856346h1514.781639v505.434678H3.805984V512.856346z m228.359041-252.051291c0-79.925664 47.384501-148.433377 114.750418-180.97454-13.701542-2.47389-27.498235-4.947779-41.199777-4.947779A186.398067 186.398067 0 0 0 119.888497 260.709905c0 102.28582 83.636499 184.685374 184.685374 184.685375 13.701542 0 28.735179-1.236945 41.199777-4.94778A199.148114 199.148114 0 0 1 232.069875 260.709905z m200.765657-149.765471l11.322802 32.446013h34.919904l-28.735179 21.218361 11.227652 32.446014-28.640029-19.981416-27.498235 19.981416 9.990708-32.350864-27.403085-21.313511h34.919904l9.990708-32.350864z m103.713065 76.11968l11.132503 33.682959h35.015053l-28.73518 19.981416 11.227653 33.682958-28.735179-21.218361-28.64003 21.218361 11.227653-33.682958-28.735179-19.981416h34.919903l11.227653-33.682959z",
    fill: "#FFFFFF",
    "p-id": 6242
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M328.266122 187.159264l11.132503 33.682959h34.919903l-28.64003 19.981416 11.227653 33.682958-28.735179-21.218361-27.403085 21.218361 11.227653-33.682958-28.735179-19.981416h34.919903l9.990708-33.682959z m168.414792 123.599331l11.227653 32.350864h34.919904l-28.73518 21.313511 11.227653 32.350864-28.64003-19.981416-27.498234 19.981416 9.990708-32.350864-27.403085-21.218361h34.919903l9.990708-32.446014z m-127.310165 0l9.990708 32.350864h34.919903l-27.403085 21.313511 9.895559 32.350864-27.403085-19.981416-28.735179 19.981416 11.227652-32.350864-28.640029-21.218361h34.919903l11.227653-32.446014z",
    fill: "#FFFFFF",
    "p-id": 6243
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSg);
export default __webpack_public_path__ + "static/media/sg.a5e9cfe3.svg";
export { ForwardRef as ReactComponent };